import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { runningInApp } from '../../services/appConstants/appConstants.js';
import styles from './Wizard.module.scss.js';
import Header from './Header/Header.js';

function Wizard(_ref) {
  var title = _ref.title,
    descriptionText = _ref.descriptionText,
    progress = _ref.progress,
    onBack = _ref.onBack,
    backText = _ref.backText,
    children = _ref.children,
    dataTestId = _ref.dataTestId,
    backDisabled = _ref.backDisabled,
    closeDisabled = _ref.closeDisabled,
    currentStep = _ref.currentStep,
    onClose = _ref.onClose,
    closeText = _ref.closeText,
    animatedText = _ref.animatedText,
    noBackButton = _ref.noBackButton;
  var headerRef = useRef(null);
  var defaultValue = 0;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    headerHeight = _useState2[0],
    setHeaderHeight = _useState2[1];
  useEffect(function () {
    var _headerRef$current;
    setHeaderHeight(((_headerRef$current = headerRef.current) === null || _headerRef$current === void 0 ? void 0 : _headerRef$current.clientHeight) || defaultValue);
  }, [currentStep, title, descriptionText]);
  return /*#__PURE__*/React.createElement("section", {
    id: dataTestId,
    className: styles.wizard
  }, /*#__PURE__*/React.createElement(Header, {
    ref: headerRef,
    title: title,
    descriptionText: descriptionText,
    onBack: onBack,
    backText: backText,
    backDisabled: backDisabled,
    closeDisabled: closeDisabled,
    backButtonDataTestId: "navigationBarPrevious",
    currentStep: currentStep,
    onClose: onClose,
    closeText: closeText,
    progress: progress,
    animatedText: animatedText,
    noBackButton: noBackButton
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.scrollable,
    style: {
      marginTop: runningInApp ? "".concat(headerHeight, "px") : "".concat(defaultValue, "px")
    }
  }, children));
}
Wizard.propTypes = {
  title: PropTypes.string.isRequired,
  descriptionText: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  onBack: PropTypes.func.isRequired,
  backText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  closeText: PropTypes.string,
  children: PropTypes.node.isRequired,
  dataTestId: PropTypes.string,
  backDisabled: PropTypes.bool,
  closeDisabled: PropTypes.bool,
  currentStep: PropTypes.string.isRequired,
  animatedText: PropTypes.bool,
  noBackButton: PropTypes.bool
};
Wizard.defaultProps = {
  dataTestId: null,
  backText: null,
  backDisabled: false,
  closeDisabled: false,
  closeText: '',
  animatedText: false,
  noBackButton: false
};

export { Wizard as default };
